export default __webpack_public_path__ + "378c75afb72bdb191018e38767a30fa7.ico";